import { Component, OnInit, Input } from '@angular/core';
import { ClaimService } from '../claim.service';
import { NgForm, ControlContainer, FormsModule } from '@angular/forms';
import { ClaimformService } from '../claimform.service';
import cssVars from 'css-vars-ponyfill';
import { FormProvidersComponent } from '../form-providers/form-providers.component';
import { InputMaskModule } from 'primeng/inputmask';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { DateMaskDirective } from '../date-mask.directive';
import { CalendarModule } from 'primeng/calendar';
import { NgIf, NgFor } from '@angular/common';
import { RadioButtonModule } from 'primeng/radiobutton';
import { NgSelectModule } from '@ng-select/ng-select';

@Component({
    selector: 'app-form-supp-disability',
    templateUrl: './form-supp-disability.component.html',
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    styleUrls: ['./form-supp-disability.component.css'],
    imports: [RadioButtonModule, FormsModule, NgIf, CalendarModule, DateMaskDirective, InputTextareaModule, InputTextModule, InputMaskModule, FormProvidersComponent, NgSelectModule]
})
export class FormSuppDisabilityComponent implements OnInit {

  @Input() claimForm: NgForm

  constructor(
    public claimformService: ClaimformService,
    public claimService: ClaimService
  ) { }

  ngOnInit(){
    cssVars();
  }

}
